// extracted by mini-css-extract-plugin
module.exports = {"whiteboardBrushColor":"WhiteboardBrushColor_whiteboardBrushColor__1AK65"};